(function () {
  if (window.__OPTI_ATC_GUARD_V2__) return;
  window.__OPTI_ATC_GUARD_V2__ = true;

  var B2B_VARIANT_ID = '49735173341481';

  function readOptiLabel() {
    return (window.OPTI && window.OPTI.label) || window.optiLabel || '';
  }

  function isAddUrl(url) {
    try { return String(url || '').indexOf('/cart/add.js') !== -1; } catch(e){ return false; }
  }

  function ensureKV(params, k, v) {
    if (v == null) return;
    if (!params.has(k) || params.get(k) === '') params.set(k, String(v));
  }

  function normalizeBody(body) {
    // returns { type, params, formData }
    if (!body) return { type: 'none' };

    // URLSearchParams
    if (body instanceof URLSearchParams) {
      return { type: 'params', params: new URLSearchParams(body.toString()) };
    }

    // FormData
    if (body instanceof FormData) {
      var fd = new FormData();
      body.forEach(function (v, k) { fd.append(k, v); });
      return { type: 'formdata', formData: fd };
    }

    // String (x-www-form-urlencoded)
    if (typeof body === 'string') {
      return { type: 'params', params: new URLSearchParams(body) };
    }

    return { type: 'unknown' };
  }

  function getIdFromParams(params) {
    var id = (params.get('id') || params.get('variant_id') || '').trim();
    return /^\d+$/.test(id) ? id : null;
  }

  function getIdFromFormData(fd) {
    var id = (fd.get('id') || fd.get('variant_id') || '').toString().trim();
    return /^\d+$/.test(id) ? id : null;
  }

  // ------------------------------
  // FETCH GUARD
  // ------------------------------
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url);
    var cfg = init || {};
    var method = (cfg.method || (input && input.method) || 'GET').toUpperCase();

    if (method === 'POST' && isAddUrl(url)) {
      var norm = normalizeBody(cfg.body);

      // URLSearchParams / string
      if (norm.type === 'params') {
        var params = norm.params;
        var id = getIdFromParams(params);

        // Block invalid add (this is your 422 "Cannot find variant")
        if (!id) {
          console.warn('[OPTI] Blocked /cart/add.js: missing variant id');
          return Promise.reject(new Error('Blocked add.js: missing variant id'));
        }

        // Only enforce for B2B variant
        if (id === B2B_VARIANT_ID) {
          var label = readOptiLabel();
          ensureKV(params, 'properties[opti-label]', label);
        }

        cfg.body = params.toString();
        cfg.headers = Object.assign({}, cfg.headers || {}, {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        });

        return _fetch.call(this, input, cfg);
      }

      // FormData
      if (norm.type === 'formdata') {
        var fd = norm.formData;
        var fid = getIdFromFormData(fd);

        if (!fid) {
          console.warn('[OPTI] Blocked /cart/add.js: missing variant id');
          return Promise.reject(new Error('Blocked add.js: missing variant id'));
        }

        if (fid === B2B_VARIANT_ID) {
          var lbl = readOptiLabel();
          if (!fd.get('properties[opti-label]')) fd.set('properties[opti-label]', lbl);
        }

        cfg.body = fd;
        return _fetch.call(this, input, cfg);
      }
    }

    return _fetch.apply(this, arguments);
  };

  // ------------------------------
  // XHR GUARD (some themes use XHR)
  // ------------------------------
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__opti_is_add__ = (String(method || '').toUpperCase() === 'POST' && isAddUrl(url));
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this.__opti_is_add__) {
      var norm = normalizeBody(body);

      if (norm.type === 'params') {
        var params = norm.params;
        var id = getIdFromParams(params);
        if (!id) {
          console.warn('[OPTI] Blocked XHR /cart/add.js: missing variant id');
          return; // hard-block
        }
        if (id === B2B_VARIANT_ID) {
          ensureKV(params, 'properties[opti-label]', readOptiLabel());
        }
        body = params.toString();
      }

      if (norm.type === 'formdata') {
        var fd = norm.formData;
        var fid = getIdFromFormData(fd);
        if (!fid) {
          console.warn('[OPTI] Blocked XHR /cart/add.js: missing variant id');
          return; // hard-block
        }
        if (fid === B2B_VARIANT_ID && !fd.get('properties[opti-label]')) {
          fd.set('properties[opti-label]', readOptiLabel());
        }
        body = fd;
      }
    }

    return _send.call(this, body);
  };
})();
